import * as CryptoJS from "crypto-js";
import Axios from "axios";
import { REACT_APP_API_ENDPOINT_LOGINWITHTOKEN, REACT_APP_API_ENDPOINT_LOGUSER_INSERTA, REACT_APP_API_ENDPOINT_LOGUSER_INSERTA_LISTA, REACT_APP_API_ENDPOINT_LOGOUT,REACT_APP_API_ENDPOINT_UPDATESERVICIO, REACT_APP_GEOMOK } from "../../Domain/Settings/SettingsVariables";
import { Post } from "../HTTP/Post";
import { FeatureGetSession } from "./FeaturesHome/FeatureGetSession";
import Swal from 'sweetalert2';

export function passwordSecurity(texto,dis){
    let cadena
    if (texto === undefined) {
      return 0;
    }
    switch (dis) {
      case dis = 1:
        cadena ="0123456789";
        break;
      case dis = 2:
        cadena ="abcdefghyjklmnñopqrstuvwxyz";
        break;
      case dis = 3:
        cadena ="abcdefghyjklmnñopqrstuvwxyz".toUpperCase();
        break;
      case dis = 4:
        cadena ="\@$!%*?&¿/#,;¡ñ-+.'";
        break;
      default:
        break;
    }
    for(let i=0; i<texto.length; i++){
        if (cadena.indexOf(texto.charAt(i),0)!=-1){
          return 1;
        }
    }
    return 0;
  
  }


export function encryptDecrypt(password, keyPass) {
  let key = keyPass.split("");
  let output = [];

  for (let i = 0; i < password.length; i++) {
    let charCode = password.charCodeAt(i) ^ key[i % key.length].charCodeAt(0);
    output.push(String.fromCharCode(charCode));
  }
  return output.join("");
}

export const loginUser= (token,data) => {
  const { AxiosPost } = Post()

  AxiosPost(`${REACT_APP_API_ENDPOINT_LOGINWITHTOKEN}`,data,token)
  .then((res)=>{
      localStorage.setItem("token", CryptoJS.AES.encrypt(res.data, "eco_scotia"));
      FeatureGetSession(res.data)
    }).catch((err)=>{
      window.location.href = `/inicia-sesion`;
    })
}

export function isActive() {
  return window.localStorage.getItem("token") &&
    window.localStorage.getItem("user")
    ? true
    : false;
}

export function getUser() {
  let user = null;
  if (isActive()) {
    user = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("user"),
        "eco_scotia"
      ).toString(CryptoJS.enc.Utf8)
    );
    user["idUsuario"] = window.atob(user["idUsuario"]);
  }
  
  return user;
}

export function getNavegator(){
  let listNavigator=['safari','chrome','edg','opera','msie','firefox'];
  let dispositivo = navigator.userAgent.split(" ");
  let infoNavegator =  navigator.userAgent.toLowerCase();
  let final;
  listNavigator.forEach((e,i)=>{
    if(infoNavegator.includes(e)){
      final = `${e.charAt(0).toUpperCase() + e.slice(1)} en ${dispositivo[1].substr(1) === 'Linux;'?'Android':dispositivo[1].substr(1)}`;
    }
  });
  return final;
}

export function getToken() {
  return CryptoJS.AES.decrypt(
   localStorage.getItem("token"),
    "eco_scotia"
  ).toString(CryptoJS.enc.Utf8);
}

export function  irEducacionFinanciera(){
  let url = 'https://www.tributi.com/cardif/educacion-financiera?utm_source=cardif&utm_medium=referral&utm_campaign=banistmo'
  window.open(url,"_blank")
}
export function parseDateHour(date,hour){
  let [month,day2,year] = date.split("-");
  let dateFull = new Date(`${day2}/${month}/${year?.split(" ")[0]} ${hour}`);
  return (<><span style={{textTransform:"capitalize"}}>
    <span className="mobileFecha mobileFechaWidth"  style={{left: window.innerWidth < 500 && window.location.pathname === '/auth/itt/networking/eventos/evento-ID' && '20px'}}>
      <span>{dateFull.toLocaleString('es-Co',{weekday:'long'})}</span>, {dateFull.toLocaleString('es-Co',{day:'2-digit'})} de <span style={{textTransform:"capitalize"}}>{dateFull.toLocaleString('es-Co',{month:'long'})}</span> {dateFull.getFullYear()} <br/>
    </span>
    <span className="mobileHora mobileHoraWidth" style={{left: window.innerWidth < 500 && window.location.pathname === '/s/itt/networking/eventos' && '32px', padding:'0'}}>
      A partir de las <span style={{textTransform:"capitalize"}}>{dateFull.toLocaleString('es-CO',{hour:'numeric',minute:'2-digit',hour12:true})}</span></span>
    </span></>);
};
export function parseDateHourNetworking(date,hour,tipoEvento, camara){
  if(camara)
    camara = camara.toLowerCase();
  else 
    camara=''
  
  let validateCamara = false;

  if ((camara.includes("camara") || camara.includes("cámara")) && (camara.includes("bogota") || camara.includes("bogotá"))) validateCamara = true

  if(validateCamara || (tipoEvento && !validateCamara)){
    let [month,day2,year] = date.split("-");
    let dateFull = new Date(`${day2}/${month}/${year?.split(" ")[0]} ${hour}`);
    return (<><span style={{textTransform:"capitalize"}}>{dateFull.toLocaleString('es-Co',{month:'long'})}</span> {dateFull.getFullYear()} <br/></>);
  }
  return parseDateHour(date, hour)
};

export function addLogs(pagina,control,extra){
  const { AxiosPost } = Post();
  let logUser ={
      idUsuario:0,
      ciudad_localizacion:'',
      fechaServidor:'',
      horaServidor:'',
      fechaLocal:'',
      horaLocal:'',
      direccion_ip:'',
      pagina:pagina,
      control:control,
      extra:extra,
  };
  if(getUser() === null){
      logUser.idUsuario = 0
  }else{
      logUser.idUsuario = getUser().idUsuario;
  }
  let date = new Date();
  logUser.fechaLocal = `${date.getDate()}/${(date.getMonth()+1)<10?`0${date.getMonth()+1}`:date.getMonth()+1}/${date.getFullYear()}`;
  logUser.horaLocal = `${date.getHours()<10?'0'+date.getHours():date.getHours()}:${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`;
  getGeoMok().then(succ=>{
      logUser.direccion_ip = succ.data.ip;
      logUser.ciudad_localizacion = succ.data.city;
      AxiosPost(`${REACT_APP_API_ENDPOINT_LOGUSER_INSERTA}`, logUser,getToken())
        .then(success=>{
        }).catch(error=>{
        });
  }).catch(error=>{
  });
  }

  export function addLogList(arrParamLogUser = [{}]){
    const { AxiosPost } = Post();
    const logUserArray = []
    const defaultLogUser = () => {
      return{
        idUsuario:0,
        ciudad_localizacion:'',
        fechaServidor:'',
        horaServidor:'',
        fechaLocal:'',
        horaLocal:'',
        direccion_ip:'',
        pagina:'',
        control:'',
        extra:'',
        resultado:'',
        identificador:''
      }
    }
  
    arrParamLogUser.forEach((log) => {
      const {pagina,control,extra,resultado,identificador} = log
      const logUser = defaultLogUser();
      logUser.pagina = pagina
      logUser.control = control
      logUser.extra = extra
      logUser.resultado = resultado
      logUser.identificador = identificador
      if(getUser() === null){
        logUser.idUsuario = 0
      }else{
        logUser.idUsuario = getUser().idUsuario;
      }
      let date = new Date();
      logUser.fechaLocal = `${date.getDate()}/${(date.getMonth()+1)<10?`0${date.getMonth()+1}`:date.getMonth()+1}/${date.getFullYear()}`;
      logUser.horaLocal = `${date.getHours()<10?'0'+date.getHours():date.getHours()}:${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`; 
      logUserArray.push(logUser)
    });
    
    if(logUserArray.length <= 0) return
  
    getGeoMok().then(succ=>
      {
        logUserArray.forEach((log)=>{
            log.direccion_ip = succ.data.ip
            log.ciudad_localizacion = succ.data.city
          })
          AxiosPost(`${REACT_APP_API_ENDPOINT_LOGUSER_INSERTA_LISTA}`, logUserArray)
        .then(success=>{
        }).catch(error=>{
        });
      }).catch(error=>
      {
        //console.log(error);
      });
    
  }

export function closeSession() {
  const { AxiosPost } = Post()
  localStorage.removeItem('pop')
  AxiosPost(`${REACT_APP_API_ENDPOINT_LOGOUT + getUser()["idUsuario"]}`,null
  ).then(succ=>{
      window.localStorage.clear();
      window.location.href = "/";
    }).catch(error=>{
      //console.log(error);
      window.localStorage.clear();
      window.location.href = "/";
    }); 
}

export function getDocumentTypes(){
  
  return localStorage.getItem('TypeDoc') && JSON.parse(localStorage.getItem('TypeDoc'));

}

export function  irOfertasLaborales(){
  let url = '/ofertas-laborales'
  window.location.replace(url,"_blank")
}

export function validateEmail(email) {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

export const validateOnlyNumbers = (exp) => {
  const regex = /^\d{0,4}(\.\d{0,4})?$/
  return regex.test(exp);
}

export const validatePhoneNumber = (number) => {
  // return /[0-9]{8}/.test(number);
  var regex = /^\d{7,10}$/;
  return regex.test(number);
}

export const validatePassword = (password) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&¿/#,;+.'ñ-])([A-Za-z\d$@$!%*?&¿/#,;+.'ñ-]|[^ ]){8,16}$/
  return regex.test(password);
}

export const validateWebsiteName = (website) => {
  const regex = /\b(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}\b/;
  return regex.test(website);
}

export function  getAlertMessage(title,text){
  Swal.fire({
    title: title,
    text: text,
    confirmButtonText: "Aceptar",
    customClass: {
        confirmButton: "button_confirm",
        closeButton: "button_close_modal",
    }
  })
}

export const updateServicio = (token,servicio,data) =>{
  const { AxiosPost } = Post()
  let dataUpdate = {
    servicio : encriptarTripleDes(servicio)
  }

  AxiosPost(`${REACT_APP_API_ENDPOINT_LOGINWITHTOKEN}`,data,token)
  .then((res)=>{
      localStorage.setItem("token", CryptoJS.AES.encrypt(res.data, "eco_scotia"));
      AxiosPost(`${REACT_APP_API_ENDPOINT_UPDATESERVICIO}`,dataUpdate,res.data)
      .then((res)=>{
      }).catch((err)=>{
        window.location.href = `/inicia-sesion`;
      })

      }).catch((err)=>{
        window.location.href = `/inicia-sesion`;
      })
}

export function encriptarTripleDes(cadena){
    const key = "Ez3JuHMwrUh9gcOjsWsI5K1A+mU+TuQA";
    const keyBytes = CryptoJS.enc.Utf8.parse(key);
    const plaintextBytes = CryptoJS.enc.Utf8.parse(cadena);

    const encryptedBytes = CryptoJS.TripleDES.encrypt(plaintextBytes, keyBytes, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const encryptedString = encryptedBytes.toString();

    return encryptedString;

} 

export function addLog (pagina, control, extra, resultado, identificador = 0) {
  let identificacion = localStorage.getItem('ccin') !== null ? localStorage.getItem('ccin') : identificador;
  const logUserObj = {
      pagina: pagina,
      control: control,
      extra: extra,
      resultado: resultado,
      identificador: identificacion,
  }

  return logUserObj;
}

export const getGeoMok = async () =>{
  try {
      return await Axios.get(`${REACT_APP_GEOMOK}`,{
        timeout: 3000 
      });
  } catch (error) {
      return {data:{
          "ip":"10.30.40.132",
          "version":"IPv4",
          "city":"",
          "country":"",
          "country_code":"",
          "country_calling_code":"",
          "time_zone":"",
          "navegator":"Chrome",
          "operating_system":"Windows"
      }}
  }
}